import { Injectable, signal, effect, inject, linkedSignal } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Theme, THEME_ATTRIBUTE } from './theme.config';
import { LOCAL_STORAGE } from '@core/storage/storage.tokens';
import { LOCAL_KEYS } from '@core/storage/storage.keys';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private document = inject(DOCUMENT);
  private storage = inject(LOCAL_STORAGE);

  private prefersDark = signal(
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false,
  );

  theme = linkedSignal<Theme>(() => (this.prefersDark() ? 'dark' : 'light'));

  constructor() {
    // Restore from storage (overrides system preference)
    const saved = this.storage.get(LOCAL_KEYS.theme);
    if (saved === 'dark' || saved === 'light') {
      this.theme.set(saved);
    }

    // Sync theme to DOM attribute
    effect(() => {
      this.document.documentElement.setAttribute(THEME_ATTRIBUTE, this.theme());
    });
  }

  toggle(): void {
    const next: Theme = this.theme() === 'dark' ? 'light' : 'dark';
    this.theme.set(next);
    this.storage.set(LOCAL_KEYS.theme, next);
  }
}
